export enum NetworkBrandLogoTone {
  Auto = 'auto',
  Light = 'light',
}
